import { useState } from "react";
import {
  Modal,
  Box,
  Typography,
} from "@mui/material";
import ImageUploader from "./ImageUploader";
import NewImageUploader from "./NewImageUploader";
import { Button } from "@material-ui/core";

function ImageUploadModal(props: UploadModalProps) {
  const [useLegacyUploader, setUseLegacyUploader] = useState(false);

  const toggleLegacyUploader = () => {
    setUseLegacyUploader((prevState) => !prevState);
  };

  const handleUploadSuccess = (newAsset: any) => {
    props.onUpload(newAsset);
    props.handleClose();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="image-upload-modal"
      className="modal"
    >
      <Box
        sx={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          minWidth: 1000,
          backgroundColor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
        }}
      >
        {useLegacyUploader ? (
          <>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" component="h2">
                Legacy Asset Uploader
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={toggleLegacyUploader}
              >
                Goto New Asset Uploader
              </Button>
            </Box>
            <ImageUploader
              handleClose={props.handleClose}
              onUpload={handleUploadSuccess}
            />
          </>
        ) : (
          <>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" component="h2">
                Asset Uploader
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={toggleLegacyUploader}
              >
                Goto Legacy Uploader
              </Button>
            </Box>
            <NewImageUploader
              handleClose={props.handleClose}
              onUpload={handleUploadSuccess}
            />
          </>
        )}
      </Box>
    </Modal>
  );
}
interface UploadModalProps {
  open: boolean;
  onUpload: (newAsset: any) => void;
  handleClose: any;
}

export default ImageUploadModal;
